module.exports = __webpack_public_path__ + "img/border_cornerShadow.c5a8d344.svg";